var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.486,
    height: 15.588,
    viewBox: "0 0 19.486 15.588",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.51,
    y1: 0.016,
    x2: 0.517,
    y2: 1.28,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#906fe0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "next",
    transform: "translate(0 -48.016)",
    opacity: 0.655
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35643",
    "data-name": "Group 35643",
    transform: "translate(9.094 48.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35642",
    "data-name": "Group 35642",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35674",
    "data-name": "Path 35674",
    d: "M233.631,53.972l-5.2-5.2a2.6,2.6,0,1,0-3.674,3.674l3.359,3.359-3.359,3.359a2.6,2.6,0,1,0,3.674,3.674l5.2-5.2a2.6,2.6,0,0,0,0-3.674Zm-.918,2.755-5.2,5.2a1.329,1.329,0,0,1-1.837,0,1.3,1.3,0,0,1,0-1.837l4.278-4.278-4.278-4.278a1.3,1.3,0,0,1,1.837-1.838l5.2,5.2a1.3,1.3,0,0,1,0,1.838Z",
    transform: "translate(-224 -48.016)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35645",
    "data-name": "Group 35645",
    transform: "translate(0 48.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35644",
    "data-name": "Group 35644",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35675",
    "data-name": "Path 35675",
    d: "M9.631,53.972l-5.2-5.2A2.6,2.6,0,1,0,.761,52.45l3.359,3.359L.761,59.169a2.6,2.6,0,1,0,3.674,3.674l5.2-5.2a2.6,2.6,0,0,0,0-3.674Zm-.918,2.755-5.2,5.2a1.329,1.329,0,0,1-1.837,0,1.3,1.3,0,0,1,0-1.837l4.278-4.278L1.68,51.531a1.3,1.3,0,0,1,1.837-1.838l5.2,5.2a1.3,1.3,0,0,1,0,1.838Z",
    transform: "translate(0 -48.016)",
    fill: "url(#linear-gradient)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateTo);
export default __webpack_public_path__ + "static/media/date-to.508a3417fb7b629510da9e8f98263575.svg";
export { ForwardRef as ReactComponent };